import { useCallback, useEffect, type RefObject } from 'react';

/**
 * Grows a textarea to fit its content. Chromium honors `field-sizing: content`
 * via CSS; this hook is the JS fallback for Firefox / WebKit.
 */
export function useTextareaAutoGrow(
  ref: RefObject<HTMLTextAreaElement | null>,
  value: string,
  enabled = true
) {
  const autoGrow = useCallback(() => {
    const ta = ref.current;
    if (!ta || !enabled) return;
    ta.style.height = 'auto';
    ta.style.height = `${ta.scrollHeight}px`;
  }, [ref, enabled]);

  useEffect(() => {
    autoGrow();
  }, [autoGrow, value, enabled]);

  return autoGrow;
}
